import React from 'react';

import VideosAdminTopicPropertiesFormContainer from './videosAdminTopicPropertiesFormContainer';

const VideosAdminTopicPropertiesContainer = () =>
  ['general', 'display'].map((schemaModule) => (
    <VideosAdminTopicPropertiesFormContainer key={schemaModule} schemaModule={schemaModule} />
  ));

export default React.memo(VideosAdminTopicPropertiesContainer);
